// exposing jQuery to window in order to be usable by external scripts
(window as any)['$'] = jQuery;
(window as any)['jQuery'] = jQuery;

import 'core-js';
import * as T from 'terrific-singleton';

// **************************
// BASE / HELPERS
// **************************
// Component Document

// Component FontFaces

// Component Resets

// Component Security
import './lib/base/security/js/security';

// Component ContentGrid

// Component Grid

// **************************
// ATOMS
// **************************
// Component Burger

import './lib/atoms/burger/js/burger';

// Component Button

import './lib/atoms/button/js/button';

// Component Heading

import './lib/atoms/heading/js/heading';

// Component Icon

import './lib/atoms/icon/js/icon';

// Component Image

import './lib/atoms/image/js/image';

// Component Video

import './lib/atoms/video/js/video';

// Component InputCheckbox

import './lib/atoms/input-checkbox/js/input-checkbox';

// Component InputCheckswitch

// Component InputSearch

import './lib/atoms/input-search/js/input-search';

// Component InputSelect

import './lib/atoms/input-select/js/input-select';

// Component InputTextarea

import './lib/atoms/input-textarea/js/input-textarea';

// Component Label

import './lib/atoms/label/js/label';

// Component Link

import './lib/atoms/link/js/link';

// Component ListUnordered

import './lib/atoms/list-unordered/js/list-unordered';

// Component LoadingIndicator

import './lib/atoms/loading-indicator/js/loading-indicator';

// Component Page-Introtext

// Component Richtext

// Component Tag

// Component TagFilter

import './lib/atoms/tag-filter/js/tag-filter';

// Component ValidationSummary

import './lib/atoms/validation-summary/js/validation-summary';

// **************************
// MOLECULES
// **************************

// Component BrandBenefitList

import './lib/molecules/brand-benefit-list/js/brand-benefit-list';

// Component BrandProductAccordion

import './lib/molecules/brand-product-accordion/js/brand-product-accordion';

// Component Breadcrumb

import './lib/molecules/breadcrumb/js/breadcrumb';

// Component CampaignDownload
import './lib/molecules/campaign-download/js/campaign-download';

// Component CategoryTags

import './lib/molecules/category-tags/js/category-tags';

// Component ClientLogo

// Component RegionLightbox

import './lib/molecules/region-lightbox/js/region-lightbox';

// Component Datasheet

import './lib/molecules/datasheet/js/datasheet';

// Component DownloadBar

// Component DownloadItem

import './lib/molecules/download-item/js/download-item';

// Component DownloadList

import './lib/molecules/download-list/js/download-list';

// Component DownloadTable

import './lib/molecules/download-table/js/download-table';

// Component FavouriteLayer

import './lib/molecules/favourite-layer/js/favourite-layer';

// Component FavouriteButton

import './lib/molecules/favourite-button/js/favourite-button';

// Component FeaturedDownload

import './lib/molecules/featured-download/js/featured-download';

// Component FilterMarketSwitch

import './lib/molecules/filter-market-switch/js/filter-market-switch';

// Component FilterMultiselect

import './lib/molecules/filter-multiselect/js/filter-multiselect';

// Component FilterProductsearch

import './lib/molecules/filter-productsearch/js/filter-productsearch';

// Component FilterCategorysearch

import './lib/molecules/filter-categorysearch/js/filter-categorysearch';

// Component FilterCategorysearchSingleLevel

import './lib/molecules/filter-categorysearch-singlelevel/js/filter-categorysearch-singlelevel';

// Component FavouritesEntryTable

import './lib/molecules/favourites-entry-table/js/favourites-entry-table';

// Component FavouritesList

import './lib/molecules/favourites-list/js/favourites-list';

// Component FilterSingleselect

import './lib/molecules/filter-singleselect/js/filter-singleselect';

// Component FilterTwoLevelMultiselect

import './lib/molecules/filter-two-level-multiselect/js/filter-two-level-multiselect';

// Component FilterWrapper

import './lib/molecules/filter-wrapper/js/filter-wrapper';

// Component ProductFilter

import './lib/molecules/product-filter/js/product-filter';

// Component TechnicalPropertyPopup

import './lib/molecules/technical-property-popup/js/technical-property-popup';

// Component FormOrder

import './lib/molecules/form-order/js/form-order';

// Component FormOrder

// Component FormUserProfile

// Component LoginData

// Component GlobalContact

import './lib/molecules/global-contact/js/global-contact';

// Component HazardousSubstances

import './lib/molecules/hazardous-substances/js/hazardous-substances';

// Component HeadingWithIcon

// Component HazardousSubstancesInfo

// Component Iframe
import './lib/molecules/iframe/js/iframeResizer';
import './lib/molecules/iframe/js/iframe';

// Component List

// Component ListIcons

import './lib/molecules/list-icons/js/list-icons';

// Component Logo

// Component Login-Button

// Component MarketSwitch

import './lib/molecules/market-switch/js/market-switch';

// Component MarketoForm

import './lib/molecules/marketo-form/js/marketo-form';

// Component MarketoFormGlobal
import './lib/molecules/marketo-form-global/js/marketo-form-global';

// Component ModalOverlay

import './lib/molecules/modal-overlay/js/modal-overlay';

// Component ModalOverlay

import './lib/molecules/modal-actions/js/modal-actions';

// Component NavigationInPage

import './lib/molecules/navigation-in-page/js/navigation-in-page.model';
import './lib/molecules/navigation-in-page/js/navigation-in-page';

// Component NavigationMain

import './lib/molecules/navigation-main/js/navigation-main';

// Component NavigationMeta

import './lib/molecules/navigation-meta/js/navigation-meta';

// Component NavigationWrapper

import './lib/molecules/navigation-wrapper/js/navigation-wrapper';

// Component NewEvent

import './lib/molecules/new-event/js/new-event';

// Component NoPermissions

// Component OrderingPlatform

import './lib/molecules/ordering-platform/js/ordering-platform';

// Component PageShare

import './lib/molecules/page-share/js/page-share';

// Component Pageintro

// Component ProductCompareButton

import './lib/molecules/product-compare-button/js/product-compare-button';

// Component ProductCompareLayer

import './lib/molecules/product-compare-layer/js/product-compare-layer';

// Component ProductFinderTeaser

import './lib/molecules/product-finder-teaser/js/product-finder-teaser';

// Component ProductFinderTeaserV2

import './lib/molecules/product-finder-teaser-V2/js/product-finder-teaser-V2';

// Component ProductList

import './lib/molecules/product-list/js/product-list';

// Component ProductLogistics

// Component ProductProperties

// Component ProductPropertiesAndDownloads

// Component ProductTable

import './lib/molecules/product-table/js/product-table';

// Component ProductTableV2

// Component PromptBox

import './lib/molecules/prompt-box/js/prompt-box';

// Component Meta

// Component Quote

// Component SearchNoResults

// Component SearchResultList

// Component SearchTabs

// Component SelectedFilterTags

// Component SelectedFilterTags

// Component SliderGallery

import './lib/molecules/slider-gallery/js/slider-gallery';

// Component SliderStage

import './lib/molecules/slider-stage/js/slider-stage';

// Component StageBrand

import './lib/molecules/stage-brand/js/stage-brand';

// Component StageHome

// Component StageKeyvisual

import './lib/molecules/stage-keyvisual/js/stage-keyvisual';

// Component StageOverview

// Component StageProduct

import './lib/molecules/stage-product/js/stage-product';

// Component StageContent

import './lib/molecules/stage-content/js/stage-content';

// Component StageContentHub

import './lib/molecules/stage-compact/js/stage-compact';

// Component StageCampaign

import './lib/molecules/stage-campaign/js/stage-campaign';

// Component StageEvent

import './lib/molecules/stage-event/js/stage-event';

// Component Table

// Component TableFilter

import './lib/molecules/table-filter/js/table-filter';

// Component TableFilterV2

import './lib/molecules/table-filterv2/js/table-filterv2';

// Component Talk

// Component Talks

import './lib/molecules/talks/js/talks';

// Component TeaserBenefit

import './lib/molecules/teaser-benefit/js/teaser-benefit';

// Component TeaserApplication

// Component TeaserButton

// Component TeaserLogin

// Component TeaserCaseStudy

// Component TeaserContactForm

import './lib/molecules/teaser-contact-form/js/teaser-contact-form';

// Component TeaserContent

// Component TeaserBrands

// Component TeaserVideo

import './lib/molecules/teaser-video/js/teaser-video';

// Component TeaserBanner

// Component TeaserFeatured

// Component TeaserLarge

import './lib/molecules/teaser-large/js/teaser-large';

// Component TeaserEvent

import './lib/molecules/teaser-event/js/teaser-event';

// Component Tooltip

import './lib/molecules/tooltip/js/tooltip';

// Component Tooltip Actions

import './lib/molecules/tooltip-actions/js/tooltip-actions';

// Component Scrollable Teaser

import './lib/molecules/scrollable-teaser/js/scrollable-teaser';

import './lib/molecules/search-flyout/js/search-flyout';

// Component Disclaimer

import './lib/molecules/disclaimer/js/disclaimer';

// Component Survey

import './lib/molecules/survey/js/survey';

// Component Lounge popup

import './lib/molecules/lounge-popup/js/lounge-popup';

// Component HTML container

import './lib/molecules/html-container/js/html-container';

// Component ICal Download

import './lib/molecules/iCal-download/js/iCal-download';

// Component Info List

import './lib/molecules/info-list/js/info-list';

// Component Investor Overview

import './lib/molecules/investor-overview/js/investor-overview';

// Component Lightbox

import './lib/molecules/lightbox/js/lightbox';

// Component LanguagePopup

import './lib/molecules/language-popup/js/language-popup';

// Component Customer lounge overview

// Component customer lounge brand intro

import './lib/molecules/customer-lounge-brand-intro/js/customer-lounge-brand-intro';

// Component customer lounge brand product table

import './lib/molecules/customer-lounge-brand-product-table/js/customer-lounge-brand-product-table';

// Component Hero Article Stage

import './lib/molecules/hero-article-stage/js/hero-article-stage';

// Component Customer lounge welcome

// Component contact teaser card

import './lib/molecules/contact-teaser-card/js/contact-teaser-card';

// Component contact teaser company card

// Component contact teaser popup

import './lib/molecules/contact-teaser-popup/js/contact-teaser-popup';

// Component contact teaser tile

// Component contact teaser large

import './lib/molecules/contact-teaser-large/js/contact-teaser-large';

// Component customer lounge project

// Component customer lounge brand teaser

// Component event list

import './lib/molecules/event-list/js/event-list';

// Component expansion panel

import './lib/molecules/expansion-panel/js/expansion-panel';

// Component marketo lightbox

import './lib/molecules/marketo-lightbox/js/marketo-lightbox';

// **************************
// ORGANISMS
// **************************
// Easteregg
import './lib/organisms/easteregg/js/pacman.min';

// Component Error404

import './lib/organisms/error-404/js/error-404';

// Component Footer

// Component Form

import './lib/organisms/form/js/form';

// Component Header

import './lib/organisms/header/js/header';

// Component Campaign Header

import './lib/organisms/header-campaign/js/header-campaign';

// Component Campaign Header

import './lib/organisms/header-campaign-collector/js/header-campaign-collector';

// Component ProductCompare

import './lib/organisms/product-compare/js/product-compare';

// Component ProductCompareV2

import './lib/organisms/product-compareV2/js/product-compareV2';

// Component ProductFinder

// Component SearchApp

// Component TeaserContentArea

import './lib/organisms/teaser-content-area/js/teaser-content-area';

// Component Customer lounge navigation

import './lib/organisms/customer-lounge-navigation/js/customer-lounge-navigation';

// Component customer lounge project teaser

import './lib/organisms/customer-lounge-project-teaser/js/customer-lounge-project-teaser';

// Component My favourites

import './lib/organisms/favourites-overview/js/favourites-overview';

// Component Overview share favourites

import './lib/organisms/overview-share-favourites/js/overview-share-favourites';

// Component teaser filter area

import './lib/organisms/teaser-filter-area/js/teaser-filter-area';

// Component home scrollable teaser

import './lib/organisms/home-scrollable-teaser/js/home-scrollable-teaser';

// Safety Data Sheet Search

import './lib/organisms/sds-search/js/sds-search';

// Teaser Tabs

import './lib/organisms/teaser-tabs/js/teaser-tabs';

// Component Confirmation
 
import './lib/molecules/confirmation/js/confirmation';

// **************************
// INIT
// **************************
(window as any)['Terrific'] = T;

// polyfill for custom events (IE)
(function() {
	if (typeof (window as any)['CustomEvent'] === 'function') {
		return false;
	}
	function CustomEvent(event: string, params: any) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}
	CustomEvent.prototype = (window as any)['Event'].prototype;
	(window as any)['CustomEvent'] = CustomEvent;
})();

const event = new CustomEvent('terrificAvailable');
document.dispatchEvent(event);

document.addEventListener('DOMContentLoaded', () => {
	T.bootstrap();
});
